export const environment = {
  production: false,
  baseURL: window._appConfig.BASE_URL,
  dynamoDB: 'prod',
};
